module.exports = __webpack_public_path__ + "static/media/logo-icon.3ac71f12.png";